import React, {useState, useEffect}from 'react';
import Select from "react-select";
import {findObjInArr} from "@app/utils/CommonFunctions";
import * as mainService from '@app/services/mainService';
import {renewCoquan, renewTrangthai} from '@app/utils/helpers';
import {useDispatch, useSelector} from "react-redux";
const CoquanTGListComponent = ({onChange, coquan_fk,filterIds,coquanName, labelname, required}) => {
    let coquanSelector = useSelector((state) => state.ttSliceName.coquanList );
    const [listTT, setListTT] = useState([]);
    const dispatch = useDispatch();
    useEffect(async () => {

        const ttmp = await renewCoquan(coquanSelector,mainService,dispatch);
        setListTT(ttmp.filter(x=> filterIds.includes(x.value)).map((x) => ({
            value: x['value'],
            label: x[coquanName]
        })));

    }, []);

    return  <>
        <label className={ required? required : "" }> { labelname ? labelname : "Cơ quan" } </label>

        <Select
            isClearable
            name="coquan_fk"
            onChange={onChange}
            value={findObjInArr(listTT,coquan_fk)}
            options={listTT}
        />
    </>
};

export default CoquanTGListComponent;
